/* eslint-disable func-names */
var Plugins = function Plugins() {};
var p = Plugins.prototype;
p.push = function (plugin) {
  this[plugin.prototype.name] = plugin;
};
export default new Plugins();


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-tween-one@2.6.8@rc-tween-one/es/plugins.js
// module id = 205
// module chunks = 0